'use client';

import React from 'react';

import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';

import './style.sass';
import Description from '../reusable-components/layouts-components__skolkovo-kids/Description';
import Goal from '../reusable-components/layouts-components__skolkovo-kids/Goal';
import Process from '../reusable-components/layouts-components__skolkovo-kids/Process';
import ContentWork from '../reusable-components/layouts-components__skolkovo-kids/ContentWork';
import Result from '../reusable-components/layouts-components__skolkovo-kids/Result';
import Numbers from '../reusable-components/layouts-components__skolkovo-kids/Numbers';
import Team from '../reusable-components/layouts-components__skolkovo-kids/Team';
import Review from '../reusable-components/layouts-components__common-cases/review';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';
import CommonNav from '../common-components/common-nav';

const gensMainTitle = {
    titleMainText:
        '&laquo;Дети в&nbsp;Сколково&raquo;. Как продвигать сообщество во&nbsp;&laquo;ВКонтакте&raquo;',
    titleAnimation: '/images/pic/skolkovo-kids/main.png',
    subText: {
        text: 'В&nbsp;этом кейсе расскажем, как сделать сообщество эффективной площадкой для бренда, найти и&nbsp;вовлечь в&nbsp;коммуникацию узкую аудиторию и&nbsp;за&nbsp;счет каких инструментов можно удержать юных инноваторов, их&nbsp;родителей и&nbsp;учителей в&nbsp;одном паблике.',
        color: '#B220B4',
    },
    subtitleContainer: [
        {
            modeText: 'Клиент',
            colorMode: '#B220B4',
            nameText: 'Технопарк &laquo;Сколково&raquo;',
        },
    ],
};

const review = {
    reviewText:
        'Команда агентства &laquo;Вебпрактик&raquo; всегда четко, профессионально и&nbsp;ответственно подходит к&nbsp;проектам и&nbsp;отдельным задачам, даже небольшим. Они всегда нацелены на&nbsp;результат. Спасибо за&nbsp;регулярные подробные отчёты о&nbsp;проделанной работе с&nbsp;прогнозами результата. Они помогают в&nbsp;принятии решений по&nbsp;развитию нашего сообщества юных инноваторов в&nbsp;Сколково.',
    reviewAuthors: [
        {
            img: '/images/pic/skolkovo-kids/avatar.png',
            title: 'Мария Захарова',
            subtitle: 'руководитель проекта &laquo;Дети в&nbsp;Сколково&raquo;',
        },
    ],
};

function SkolkovoKids() {
    const casePathname = '/cases/marketing/skolkovo-kids';
    const adjacentCase = getAdjacentCase(casePathname);

    return (
        <section className="skolkovo-kids">
            <CommonNav
                className="skolkovo-kids__nav"
                stepOne="Главная"
                stepTwo="Кейсы"
                stepThree="Маркетинг"
                link1={'/'}
                link2={'/cases'}
                link3={true}
            />
            <MainTitle
                classNameText="skolkovo-kids__title-text"
                classNameTitle="skolkovo-kids__title"
                classNameImg="skolkovo-kids__img"
                MainTitle={gensMainTitle}
            />
            <Description />
            <Goal />
            <Process />
            <ContentWork />
            <Result />
            <Numbers />
            <div className="skolkovo-kids__text">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    В&nbsp;планах развитие сообщества и&nbsp;увеличение подписчиков до&nbsp;10К,
                    чтобы работать на&nbsp;следующем уровне воронки&nbsp;&mdash; лидогенерация при
                    помощи лид-форм VK&nbsp;для продвижения платных мероприятий и&nbsp;записи
                    на&nbsp;образовательные курсы.
                </ScrollAnimation>
            </div>
            <Team />
            <Review Review={review} />
            <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper>
                    <OfferButton linkText="Нанять в команду" />
                </FullWrapper>
            </ScrollAnimation>
            {adjacentCase && (
                <NextProject
                    NextProject={{
                        nextProjectTitle: adjacentCase.case.title,
                        nextProjectImg: adjacentCase.case.image,
                        nextProjectLink: adjacentCase.case.router,
                        nextProjectText: adjacentCase.case.description,
                        nextProjectLabel: adjacentCase.label,
                    }}
                />
            )}
        </section>
    );
}

export default SkolkovoKids;
